import type { CMSPhotoDTO } from "~/features/cms/types/dto";
import { IconButton, Link, styled } from "@schaeffler-commerce/design-system";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { lineClamp } from "~/common/components/icon/FontUtils";

interface Props extends Omit<CMSPhotoDTO, "type"> {
  className?: string;
}

export const CMSPhoto = (props: Props) => {
  const openInNewTab = props.openInNewTab;
  return (
    <Card
      key={props.index}
      style={{
        width: props.getWidth(props.getWidthParam),
        marginRight: props.getMargin(props.relativeIndex, props.index),
      }}
    >
      <GalleryImage src={props.imageUrl} />
      <PhotoFooter
        style={{
          opacity: props.getWidth(props.getWidthParam) == "100%" ? 1 : 0,
        }}
      >
        <>
          <div>
            <FooterTitle>{props.title}</FooterTitle>
            <FooterSubTitle>{props.body}</FooterSubTitle>
          </div>
          {props.url && (
            <Link href={props.url} target={openInNewTab ? "_blank" : undefined}>
              <IconButton variant="contained" color={"secondary"} size={"medium"} tabIndex={-1}>
                <OpenInNewIcon />
              </IconButton>
            </Link>
          )}
        </>
      </PhotoFooter>
    </Card>
  );
};

const Card = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  height: "430px",
  transition: "width 0.5s ease-in-out, margin-right 0.5s ease-in-out",
  [theme.breakpoints.down("tablet")]: {
    height: "330px",
  },
}));

const GalleryImage = styled("img")(({ theme }) => ({
  height: "320px",
  borderRadius: "28px",
  objectFit: "cover",
  overflow: "hidden",
  [theme.breakpoints.down("tablet")]: {
    height: "220px",
  },
}));

const PhotoFooter = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  margin: "10px 0",
  height: "100px",
  width: "100%",
  position: "absolute",
  top: "320px",
  left: 0,
  zIndex: 5,
  transition: "opacity 0.5s ease-in-out",
  [theme.breakpoints.down("tablet")]: {
    top: "220px",
  },
}));

const FooterTitle = styled("p")(({ theme }) => ({
  ...theme.typography.bodyLarge,
  fontWeight: 400,
  ...lineClamp(1),
}));

const FooterSubTitle = styled("p")(({ theme }) => ({
  ...theme.typography.bodyMedium,
  ...lineClamp(3),
}));
